module.exports = __webpack_public_path__ + "static/media/Ειδικο  Δημ Σχολ Κωφων Λυκοβρυσης.ce5f9f1e.mp4";